import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UserFunction } from "../../api/models/user-function";

export const DISABLED = "DISABLED";

export function isNotAuthorizedUser(userFunction: UserFunctionEnum, userFunctions: UserFunction[]): boolean {
  let isNotAuthorized: boolean = true;
  userFunctions?.forEach((func: UserFunction) => {
    if (func.function === userFunction.toString() && func.action !== DISABLED) {
      isNotAuthorized = false;
    }
  });
  return isNotAuthorized;
}

export function isNotPresentFunction(userFunction: UserFunctionEnum, userFunctions: UserFunction[]): boolean {
  let isNotPresent: boolean = true;
  userFunctions?.forEach((func: UserFunction) => {
    if (func.function === userFunction.toString()) {
      isNotPresent = false;
    }
  });
  return isNotPresent;
}
